import * as React from "react";

const SvgPaste = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="paste_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#paste_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.778 20.286q-.735 0-1.256-.537A1.79 1.79 0 0 1 2 18.457v-12.8q0-.754.522-1.291a1.69 1.69 0 0 1 1.256-.537h3.71q.245-.8.956-1.315A2.6 2.6 0 0 1 10 2q.889 0 1.589.514t.944 1.315h3.69q.733 0 1.255.537T18 5.657V11h-1.778V5.657h-1.778V8.4H5.556V5.657H3.778v12.8H10v1.829zM10 5.657a.85.85 0 0 0 .633-.263.9.9 0 0 0 .256-.651.9.9 0 0 0-.256-.652A.85.85 0 0 0 10 3.83a.85.85 0 0 0-.633.262.9.9 0 0 0-.256.652q0 .389.256.651.255.264.633.263M12 13h8v9.333h-8zm1.333 1.333h5.334v1.334h-5.334zM18.667 17h-5.334v1.333h5.334zm-5.334 2.667h5.334V21h-5.334z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgPaste;
